<template>
  <footer class="border-t border-gray-100 bg-white px-4 pt-5 pb-40" aria-label="網站尾部">
    <div class="flex items-center justify-between gap-3">
      <div class="min-w-0">
        <img
          v-if="imgs.logo_long"
          :src="imgs.logo_long"
          :alt="appName"
          width="112"
          height="40"
          class="h-9 w-auto max-w-[120px] object-contain"
        />
        <p class="mt-2 truncate text-sm font-bold text-gray-900">{{ appName }}</p>
      </div>

      <div v-if="visibleSocialList.length && !isAlipayHK" class="flex flex-none items-center gap-2">
        <template v-for="item of visibleSocialList">
          <a
            v-if="item.external"
            :key="item.name"
            :href="item.src"
            :aria-label="item.name"
            class="flex h-8 w-8 items-center justify-center rounded-lg bg-gray-50 active:bg-gray-100"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img :src="item.icon" :alt="item.name" width="20" height="20" class="h-5 w-5" />
          </a>
          <nuxt-link
            v-else
            :key="item.name"
            :to="localePath(item.src)"
            :aria-label="item.name"
            class="flex h-8 w-8 items-center justify-center rounded-lg bg-gray-50 active:bg-gray-100"
          >
            <img :src="item.icon" :alt="item.name" width="20" height="20" class="h-5 w-5" />
          </nuxt-link>
        </template>
      </div>
    </div>

    <nav
      class="mt-5 grid grid-cols-2 gap-x-4 gap-y-2 border-y border-gray-100 py-4 text-xs text-gray-600"
      aria-label="網站資訊"
    >
      <nuxt-link
        v-for="item of restList"
        :key="item.to"
        :to="localePath(item.to)"
        class="truncate active:text-primary"
      >
        {{ item.tag }}
      </nuxt-link>
    </nav>

    <div class="mt-4 space-y-3 text-xs leading-5 text-gray-500">
      <section v-for="branch in footer.branches" :key="branch.title">
        <h3 class="font-semibold text-gray-700">{{ branch.title }}</h3>
        <p class="break-words">{{ branch.address }}</p>
      </section>

      <a
        v-if="info.email"
        :href="`mailto:${info.email}`"
        class="inline-flex font-semibold text-primary active:opacity-70"
      >
        {{ info.email }}
      </a>

      <p class="border-t border-gray-100 pt-3 text-[11px] text-gray-400">
        {{ year }} {{ footer.company }}. All rights reserved.
      </p>
    </div>
  </footer>
</template>

<script>
import facebookIcon from "@/static/Facebook_icon.svg";
import instagramIcon from "@/static/Instagram_icon.svg";
import wechatIcon from "@/static/Wechat_icon.svg";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      year: new Date().getFullYear(),
    };
  },

  computed: {
    ...mapGetters({
      info: "app/info",
      imgs: "app/imgs",
      isAlipayHK: "app/isAlipayHK",
    }),

    appName() {
      return this.info.name || "達人商城";
    },

    footer() {
      const footer = this.info.footer || {};

      return {
        company: footer.company || "",
        branches: footer.branches || [],
      };
    },

    restList() {
      return [
        { tag: "購買流程", to: "/procedure" },
        { tag: "退換政策", to: "/teams/policies/refund" },
        {
          tag: "用戶註冊協議",
          to: "/teams/policies/service",
        },
        { tag: "隱私政策", to: "/teams/policies/privacy" },
        { tag: `關於${this.appName}`, to: "/about" },
      ];
    },

    socialList() {
      return [
        {
          name: "Facebook",
          icon: facebookIcon,
          src: this.info.facebook,
          external: true,
        },
        {
          name: "Instagram",
          icon: instagramIcon,
          src: this.info.instagram,
          external: true,
        },
        {
          name: "WeChat",
          icon: wechatIcon,
          src: "/about",
          external: false,
        },
      ];
    },

    visibleSocialList() {
      return this.socialList.filter((item) => item.src);
    },
  },
};
</script>

<style lang="scss" scoped></style>
